export function secondaryMenuInit(secondaryMenuClass) {
  // MOBILE SECONDARY NAV
  if ($(secondaryMenuClass).length > 0) {
    $(secondaryMenuClass)
      .clone()
      .appendTo("#menu");
  }
}

export function menuInit(menuClass) {
  // MENU TOGGLE
  if ($(menuClass).length > 0) {
    $(menuClass).click(function(e) {
      e.preventDefault();
      var url = $(this).attr("href");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(url).slideUp();
      } else {
        $(this).addClass("active");
        $(url).slideDown();
      }
    });
  }
}
